import { render, staticRenderFns } from "./BriefReport.vue?vue&type=template&id=6745b45a&scoped=true"
import script from "./BriefReport.vue?vue&type=script&lang=js"
export * from "./BriefReport.vue?vue&type=script&lang=js"
import style0 from "./BriefReport.vue?vue&type=style&index=0&id=6745b45a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745b45a",
  null
  
)

export default component.exports